import {
  REPORT_ADDRESS_SUGGESTION_NO_RESULTSET,
  REPORT_ADDRESS_SUGGESTION_RESULTSET,
  REPORT_ADDRESS_SUGGESTION_MODIFIED,
} from 'redux/modules/address-suggestion/actions/types';
import { addressSelector } from 'redux/modules/address-suggestion/selectors';

const addressSuggestionSearch = () => ({
  type: REPORT_ADDRESS_SUGGESTION_NO_RESULTSET,
});

const addressSuggestionSearchResultSet = () => ({
  type: REPORT_ADDRESS_SUGGESTION_RESULTSET,
});

const addressSuggestionModified = address => (dispatch, getState) => {
  const control = addressSelector(getState());
  return dispatch({
    type: REPORT_ADDRESS_SUGGESTION_MODIFIED,
    address,
    control,
  });
};

export { addressSuggestionSearch, addressSuggestionSearchResultSet, addressSuggestionModified };
